// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ow-0";
export var discountCodeInput = "_ow-1";